<template>
    <div style="height: 100%">
        <div class="sa-flexbox" style="padding-bottom: 20px">
            <div class="sa-flexbox-header" style="padding: 10px">
                <!--  -->
                <b-form @submit.prevent="onSubmit">
                    <b-row>
                        <b-col xs="3" sm="3" md="4" lg="4" xl="4">
                            <label>Nominativo</label>
                            <b-form-input v-model="filtro.nominativo" type="search" placeholder="Nominativo"></b-form-input>
                        </b-col>
                        <b-col xs="3" sm="3" md="4" lg="4" xl="4">
                            <label>Data Dal</label>
                            <date-picker v-model="filtro.dataDal" format="DD-MM-YYYY" value-type="timestamp" type="date"></date-picker>
                        </b-col>
                        <b-col xs="3" sm="3" md="4" lg="4" xl="4">
                            <label>Data Al</label>
                            <date-picker v-model="filtro.dataAl" format="DD-MM-YYYY" value-type="timestamp" type="date"></date-picker>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col class="sa-padding-right text-right">
                            <b-button @click="onClickResetFilter" variant="danger">Reset</b-button>
                            <b-button type="submit" variant="info">Cerca</b-button>
                        </b-col>
                    </b-row>
                </b-form>
            </div>
            <!-- <b-tabs id="tabsPrenotazioni" ref="tabsPrenotazioni" v-model="activeTabIndex" nav-wrapper-class="sa-tab-items" content-class="mt-3" class="sa-tab" style="height: 100%; padding-bottom: 25px" fill @input="onInputTabs"></b-tabs> -->
            <div class="sa-flexbox-body">
                <div class="d-flex flex-column">
                    <b-row class="sa-label-info" style="margin-left: 0.5rem; margin-right: 0.5rem">
                        <b-col lg="3">
                            <p>Records Totali: {{ rows }}</p>
                        </b-col>

                        <b-col lg="9">
                            <b-pagination :total-rows="rows" v-model="currentPage" :per-page="perPage" align="right" size="sm"> </b-pagination>
                        </b-col>
                    </b-row>
                </div>

                <div class="sa-test" style="height: 100%">
                    <div class="sa-card-list">
                        <b-row>
                            <b-col v-for="item of items" :key="item.id" class="sa-card-list-col" cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                                <div class="sa-card-list-container">
                                    <div class="sa-card-list-container-body">
                                        <div>
                                            <img src="@/assets/images/ico_m.png" />
                                        </div>
                                        <div style="flex: 1; padding-left: 5px">
                                            <span class="sa-card-list-container-body-row"
                                                ><b>{{ item.title }}</b></span
                                            >
                                            <span class="sa-card-list-container-body-row">
                                                Data Ora Appuntamento: <strong>{{ formatDateTime(item.dataInizio) }}</strong></span
                                            >
                                            <span class="sa-card-list-container-body-row">
                                                Data Ora Fine Appuntamento: <strong>{{ formatDateTime(item.dataFine) }}</strong></span
                                            >
                                        </div>
                                    </div>
                                    <div class="sa-card-list-container-footer text-right">
                                        <b-button v-b-tooltip.hover size="sm" variant="outline-success outline-secondary-noborder pull-right" title="Prenota Slot" @click="onClickPrenotaSlot(item)" class="mr-1 no-text">
                                            <b-icon icon="book" variant="outline-sucess"></b-icon>
                                        </b-button>
                                    </div>
                                </div>
                            </b-col>
                        </b-row>
                    </div>
                </div>
            </div>

            <div class="d-flex flex-column">
                <b-row class="sa-label-info" style="margin-left: 0.5rem; margin-right: 0.5rem">
                    <b-col lg="3">
                        <p>Records Totali: {{ rows }}</p>
                    </b-col>

                    <b-col lg="9">
                        <b-pagination :total-rows="rows" v-model="currentPage" :per-page="perPage" align="right" size="sm"> </b-pagination>
                    </b-col>
                </b-row>
            </div>
        </div>
        <modal-error ref="cmpModalError"> </modal-error>
        <ExternalPrenotazioniPrenotaSlotModal ref="mdlExternalPrenotazioniPrenotaSlotModal" />
    </div>
</template>

<script>
import DatePicker from "vue2-datepicker";
import ModalError from "../../../template/components/modal/components/ModalError.vue";
import UtilityMixin from "../../utility/UtilityMixin";

import ExternalPrenotazioniPrenotaSlotModal from "./ExternalPrenotazioniPrenotaSlotModal.vue";
// import IdentityManagerModalEditComponent from "./IdentityManagerModalEditComponent.vue";
export default {
    inject: ["openShowModalLoading", "closeShowModalLoading"],
    mixins: [UtilityMixin],
    components: { ModalError, ExternalPrenotazioniPrenotaSlotModal, DatePicker },
    data() {
        return {
            pathResource: "/externalprenotazioni",
            idAmbulatorio: "",
            pathResourcePazienti: "/pazienti",
            activeTabIndex: 0,
            items: [],
            rows: 0,
            perPage: 50,
            currentPage: 1,
            filtro: { idAmbulatorio: null, dataDal: new Date().getTime(), dataAl: null, nominativo: "" },
            listKey: 0,
            paziente: { id: null },
            prenotazione: {},
            fields: [
                {
                    label: "*",
                    key: "index",
                },
                {
                    label: "Nominativo",
                    key: "nominativo",
                },
                {
                    label: "Prestazione",
                    key: "prestazione",
                    sortable: true,
                    //thStyle: "width: 7rem",
                },
                {
                    label: "Data/Ora Prenotazione",
                    key: "dataPrenotazione",
                },
                {
                    label: "Stato Attuale",
                    key: "stato",
                },
                {
                    label: "Stato Attuale Data/Ora",
                    key: "statoDataOra",
                },
                {
                    label: "",
                    class: "sa-table-column-action-double",
                    key: "actions",
                },
            ],
        };
    },
    mounted() {
        // let me = this;
    },
    watch: {
        currentPage() {
            this.loadData();
        },
    },
    methods: {
        init() {
            let me = this;
            let sessionStorage = window.sessionStorage;
            me.idAmbulatorio = sessionStorage.getItem("idAmbulatorio");
            me.filtro.idAmbulatorio = me.idAmbulatorio;
            // console.log(me.filtro);

            me.loadData();
        },
        loadData() {
            let me = this;
            me.$emit("beforeLoadData");
            me.items = [];
            this.openShowModalLoading();
            UtilityMixin.methods.loadDataResources(me.pathResource, me.filtro, me.loadDataSuccess, me.loadDataError);
        },
        loadDataSuccess(response) {
            let me = this;
            me.items = response.data.data;
            me.items = me.items.filter((item) => item.title.toUpperCase() !== "BLOCCO TIMESLOT");
            me.items = me.items.filter((item) => item.title.toUpperCase() !== "Blocco Timeslotxxxx".toUpperCase());
            me.items = me.items.filter((item) => item.title.toUpperCase() !== "Blocco Timeslot Pausa pranzo ".toUpperCase());
            me.items = me.items.filter((item) => item.title.toUpperCase() !== "Blocco Timeslot Pausa pranzo".toUpperCase());
            me.items = me.items.filter((item) => item.appointmentStatus.toLowerCase() !== "cancelled");
            me.items = me.items.filter((item) => item.appointmentStatus.toLowerCase() !== "noshow");
            // console.log(me.filtro.nominativo);
            if (me.filtro.nominativo !== null && me.filtro.nominativo !== "") {
                me.items = me.items.filter((item) => item.title.toLowerCase().includes(me.filtro.nominativo.toLowerCase()));
            }
            //filtro.nominativo
            me.$emit("afterLoadData");
            me.rows = me.items.length;
            me.listKey++;
            this.closeShowModalLoading();
        },
        loadDataError(response) {
            let me = this;
            me.$emit("afterLoadData", response);
            me.$bvToast.toast("Errore durante il caricamento", {
                title: "Errore",
                variant: "danger",
                solid: true,
            });
            this.closeShowModalLoading();
        },
        onClickPrenotaSlot(item) {
            this.$refs.mdlExternalPrenotazioniPrenotaSlotModal.init(item);
        },
        onClickPresaInCarico(item) {
            let me = this;
            me.$emit("beforeLoadData");
            me.prenotazione = item;
            me.checkPresentAnagrafica();
        },
        checkPresentAnagrafica() {
            let me = this;
            let path = process.env.VUE_APP_PATH_API + me.pathResourcePazienti + "/identificativo/" + me.prenotazione.identificativo;
            this.openShowModalLoading();
            UtilityMixin.methods.restCallGet(path, null, me.checkPresentAnagraficaSuccess, me.checkPresentAnagraficaError);
        },
        // checkPresentAnagraficaSuccess(response) {
        //     let me = this;
        //     me.paziente = response.data.data;
        //     this.closeShowModalLoading();
        //     me.$emit("afterLoadData");
        //     me.$refs.mdlExternalPrenotazioniPaziente.init(me.paziente, me.prenotazione.id);
        // },
        checkPresentAnagraficaSuccess(response) {
            let me = this;
            me.paziente = response.data.data;
            // residenza
            me.paziente.indirizzoResidenza = me.prenotazione.address1;
            me.paziente.comuneResidenzaCodiceIstat = me.prenotazione.city;
            me.paziente.provinciaResidenza = me.prenotazione.country;
            me.paziente.capResidenza = me.prenotazione.postalCode;
            // domicilio
            me.paziente.indirizzoDomicilio = me.prenotazione.address1;
            me.paziente.comuneDomicilioCodiceIstat = me.prenotazione.city;
            me.paziente.provinciaDomicilio = me.prenotazione.country;
            me.paziente.capDomicilio = me.prenotazione.postalCode;
            // contatti
            me.paziente.telefono = me.prenotazione.phone;
            me.paziente.email = me.prenotazione.email;
            this.closeShowModalLoading();
            me.$emit("afterLoadData");
            me.$refs.mdlExternalPrenotazioniPaziente.init(me.paziente, me.prenotazione.id);
        },
        checkPresentAnagraficaError(error) {
            let me = this;
            me.$emit("afterLoadData", error);
            me.paziente.id = null;
            me.paziente.identificativo = me.prenotazione.identificativo;
            me.paziente.cognome = me.prenotazione.cognome;
            me.paziente.nome = me.prenotazione.nome;
            me.paziente.indirizzoResidenza = me.prenotazione.address1;
            me.paziente.indirizzoDomicilio = me.prenotazione.address1;
            me.paziente.note = "";
            me.paziente.regioneNascita = null;
            me.paziente.regioneResidenza = null;
            me.paziente.regioneDomicilio = null;
            me.paziente.sesso = null;
            me.paziente.comuneDomicilioCodiceIstat = me.prenotazione.city;
            me.paziente.provinciaDomicilio = me.prenotazione.country;
            me.paziente.comuneNascitaCodiceIstat = null;
            me.paziente.provinciaNascita = null;
            me.paziente.comuneResidenzaCodiceIstat = me.prenotazione.city;
            me.paziente.provinciaResidenza = me.prenotazione.country;
            me.paziente.capResidenza = me.prenotazione.postalCode;
            me.paziente.capDomicilio = me.prenotazione.postalCode;
            me.paziente.telefono = me.prenotazione.phone;
            me.paziente.email = me.prenotazione.email;
            me.paziente.gruppoSanguigno = "patient.blood.lblUndefined";
            me.$refs.mdlExternalPrenotazioniPaziente.init(me.paziente, me.prenotazione.id);
        },
        onClickResetFilter() {
            this.filtro = {
                idAmbulatorio: this.idAmbulatorio,
                dataDal: new Date().getTime(),
                dataAl: null,
                nominativo: "",
            };
            this.loadData();
        },
        onSubmit() {
            this.loadData();
        },
    },
};
</script>

<style></style>
